var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"request-type-disclaimers__container"},_vm._l((_vm.options),function(option,index){return _c('p',{key:option.id},[_c('b',[_c('span',{class:{'employee-icon__container': index== 0}},[_c('i',{staticClass:"ml-3 mr-1",class:option.icon})]),_vm._v(" "+_vm._s(option.label)+": ")]),_c('span',[_vm._v(_vm._s(option.disclaimer))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }